import React, { useState, useEffect } from "react";
import PWAHeader from "../common/PWAHeader";
import DatePickerRow from "../common/DatePickerRow";
import { LocalDrinkOutlined, Delete, Add, LocalDrinkRounded } from '@mui/icons-material';
import './Fsn26LogWater.css';
import { deleteUserLogData, fetchWaterData, saveWaterLogData, waterListGetUserData, waterLogPostData } from '../apiservices/ApiService';
import PrimaryButton from "../common/PrimaryButton";
const Fsn26LogWater = ({ onTap }) => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [waterConsumed, setWaterConsumed] = useState(0);
  const [targetWater, setTargetWater] = useState(3);
  const [loggedEntries, setLoggedEntries] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [waterLevelHeight, setWaterLevelHeight] = useState(0);

  const handleSubmit = async () => {

    console.log("handleSubmit");

  };
  const quickLogOptions = [
    { value: 0.2, label: '200 ml', icon: 'glass' },
    { value: 0.5, label: '500 ml', icon: 'bottle' },
    { value: 0.75, label: '750 ml', icon: 'large-bottle' },
    { value: 1, label: '1 Litre', icon: 'huge-bottle' }
  ];

  useEffect(() => {
    updateWeekFromDate(selectedDate);
    // Load entries for selected date
    const fetchData = async () => {
      updateWeekFromDate(selectedDate);
      // Load entries for selected date
      try {
        const response = await fetchWaterData({
          date: selectedDate,
          dataInDepth: "1",
        });

        const data = response;

        if (data.length > 0) {
          setLoggedEntries(data);
        }
      } catch (error) {
        console.error("Error fetching water data:", error);
      }

      loadEntriesForDate(selectedDate);
    };

    fetchData();
  }, [selectedDate]);

  useEffect(() => {
    calculateTotalWater();
  }, [loggedEntries]);

  const updateWeekFromDate = (date) => {
    const currentDate = new Date(date);
    const startDate = new Date(currentDate.getFullYear(), 0, 1);
    const days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));
    const weekNumber = Math.ceil(days / 7);
    // setCurrentWeek(weekNumber);
  };

  const loadEntriesForDate = (date) => {
    // Filter entries for selected date
    const filteredEntries = loggedEntries.filter(entry => entry.date == date);

    calculateTotalWater(filteredEntries);
  };

  const calculateTotalWater = (entries = loggedEntries) => {
    console.log(entries, "filteredEntries")
    const total = entries
      .filter(entry => entry.date === selectedDate)
      .reduce((sum, entry) => sum + parseInt(entry.amountInMl), 0);

    console.log("i am called 1", total)
    setWaterConsumed(total)
    setWaterLevelHeight(getWaterLevelHeight(total))
  };
  const getCurrentTime = () => {
    const now = new Date();

    // Format date and time
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Get month (0-based index)
    const day = String(now.getDate()).padStart(2, '0'); // Get day
    const hours = String(now.getHours()).padStart(2, '0'); // Get hours
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Get minutes
    const seconds = String(now.getSeconds()).padStart(2, '0'); // Get seconds

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const getCurrentTimeInSeconds = () => {
    const now = new Date();
    return Math.floor(now.getTime() / 1000); // Convert milliseconds to seconds
  };
  const formatTimestamp = (isoString) => {
    const date = new Date(isoString);
    const options = { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleString('en-US', options).replace(',', '');
  };
  const handleQuickLog = (amount) => {
    setSelectedAmount(amount);
  };

  const handleLog = async (e) => {
    e.preventDefault();
    try {

      let payload = JSON.stringify(
        [{
          serverWaterId: "0",
          quantity: "0",
          unit: "ML",
          status: "new",
          localWaterId: `${getCurrentTimeInSeconds()}`,
          source: "goqii",
          date: `${selectedDate}`,
          amountInMl: selectedAmount * 1000,
          createdTime: getCurrentTime(),

        }]
      )
      const response = await saveWaterLogData({ data: payload });

      console.log("water/add_water API response:", response);
      console.log(payload.createdTime)
    } catch (error) {
      console.error('Error updating profile:', error);
    }
    console.log(selectedDate, selectedAmount)

    const response = await fetchWaterData({
      date: selectedDate,
      dataInDepth: "1",
    });
    let newEntry
    let data = response

    if (data.length > 0) {
      newEntry = data[data.length - 1]
    }

    setLoggedEntries(data);
    setSelectedAmount(null);

  };

  const handleDeleteEntry = (id) => {
    setLoggedEntries(loggedEntries.filter(entry => entry.serverWaterId !== id));
    setSelectedEntry(null);

    const fetchData = async () => {
      const payload = JSON.stringify([
        {
          serverWaterId: id,
          status: "old",
          source: "GOQii",
          date: `${selectedDate}`,
        },
      ]);

      const deletedResponse = await deleteUserLogData({ data: payload });

      const response = await fetchWaterData({
        date: selectedDate,
        dataInDepth: "1",
      });
      setLoggedEntries(response);
    }
    fetchData()
  };

  const getWaterLevelHeight = (total) => {
    const percentage = (total / (targetWater * 1000)) * 100;
    console.log(percentage, "percentage", total, targetWater
    )
    return `${Math.min(percentage, 100)}%`;
  };

  // Custom icon component based on serving size
  const ServingIcon = ({ type }) => {
    return (
      <div className={`serving-icon ${type}`}>
        <LocalDrinkRounded />
      </div>
    );
  };

  const WaterLogContent = () => (
    <div className="water-log-container">
      <div className="consumption-section">
        <div className="section-title">Water consumed</div>
        <div className="consumption-value">   {(waterConsumed.toFixed(0) / 1000).toFixed(2)} L</div>

        <div className="glass-container">
          <div
            className="water-level"
            style={{ height: waterLevelHeight }}
          >
            <div className="level-indicator">
              <div className="ripple"></div>
            </div>
          </div>
        </div>

        <div className="target-value">{targetWater} L</div>
      </div>

      <div className="quick-log-section">
        <div className="section-title">Quick Log</div>
        <div className="quick-log-grid">
          {quickLogOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => handleQuickLog(option.value)}
              className={`quick-log-button ${selectedAmount === option.value ? 'selected' : ''}`}
            >
              <ServingIcon type={option.icon} />
              <span className="option-label">{option.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Log Button */}
      <PrimaryButton  onClick={handleLog} label="Log" />

      <div className="logged-entries-section">
        <div className="section-title">Logged Water</div>
        <div className="entries-list">
          {loggedEntries
            .filter(entry => entry.date === selectedDate)
            .map((entry) => (
              <div
                key={entry.serverWaterId}
                className="entry-item"
                onTouchStart={() => {
                  const timer = setTimeout(() => {
                    setSelectedEntry(entry.serverWaterId);
                  }, 500);
                  return () => clearTimeout(timer);
                }}
              >
                <div className="entry-content">
                  <LocalDrinkOutlined className="water-drop-icon" />
                  <div className="entry-details">
                    <div className="entry-title">Water</div>
                    <div className="entry-amount">{(entry.amountInMl / 1000).toFixed(2)} L</div>
                  </div>
                </div>
                <div className="timestamp-container">
                  <div className="timestamp-label">Logged at</div>
                  <div className="timestamp-value">
                    {formatTimestamp(entry.createdTime)}
                  </div>
                </div>
                {selectedEntry === entry.serverWaterId && (
                  <button
                    onClick={() => handleDeleteEntry(entry.serverWaterId)}
                    className="delete-button"
                  >
                    <Delete />
                  </button>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="App">
      <PWAHeader title={onTap?.FAI?.title || "Log Water"} />
      <DatePickerRow
          selectedDate={selectedDate}
          onDateSelect={setSelectedDate}
          currentWeek={currentWeek}
          setCurrentWeek={setCurrentWeek}
          restrictPastDates={false}  // Restrict past dates for appointment booking
          restrictFutureDates={true} // Allow future dates
        />
      <div className="app-container">

        <WaterLogContent />
      </div>
    </div>

  );
};

export default Fsn26LogWater;
